if (!customElements.get("td-related-products")) {
  class TdRelatedProducts extends HTMLElement {
    constructor() {
      super();
      this.ADD_BUTTONS = this.querySelectorAll("[data-add-button]")
    }

    connectedCallback() {
      this.attachListeners();
    }

    attachListeners() {
      this.ADD_BUTTONS.forEach((button) => {
        button.addEventListener("click", () => {
          this.addProductToCart(button);
        });
      });
    }

    addProductToCart(button) {
      let variantId = button.dataset.addButton;
      let items = [{id: variantId,quantity: 1}];
      fetch("/cart/add.js", {
        body: JSON.stringify({ items: items }),
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        method: "post",
      })
      .then((response) => response.json())
      .then((data) => {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {bubbles: true}));
        document.dispatchEvent(new CustomEvent('on:cart:change', {bubbles: true}));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {bubbles: true}));
      }).catch((err) => {
        console.error(err);
      });
    }
  }

  customElements.define('td-related-products', TdRelatedProducts);
}